import React from 'react'
import PropTypes from 'prop-types'
import OpalHeading from '../../../../components/opal/OpalHeading'
import Icon from '../../../../components/atoms/Icon'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import LinkCard from '../common/LinkCard'
import { ICON_NAMES } from '../../../../constants'

const DEFAULT_ICON = ICON_NAMES.cube

function buildSkillUrl (skill, content) {
  const params = new URLSearchParams()
  params.set('skillId', skill.skillId)
  params.set('skillName', skill.skillName)
  const defaultPrompt = content.defaultPrompt
  if (defaultPrompt) {
    params.set('prompt', defaultPrompt)
  }
  if (content.greetingMessage) {
    params.set('greeting', content.greetingMessage)
  }
  const focus = content.focuses?.[0]
  if (focus === 'none' || focus === 'client') {
    params.set('focusMode', focus)
  }
  return `/denali-ai/new?${params.toString()}`
}

function SkillCard ({ skill }) {
  const content = skill.skillContent || {}
  const to = buildSkillUrl(skill, content)

  return (
    <LinkCard to={to}>
      <FlexRow style={{ alignItems: 'flex-start' }}>
        <FlexColumn className='gap-sm flex-1' style={{ minWidth: 0 }}>
          <FlexRow style={{ gap: '12px', alignItems: 'center' }}>
            <Icon name={content.iconName || DEFAULT_ICON} customSize='20px' />
            <OpalHeading className='font-size-md'>
              {skill.skillName}
            </OpalHeading>
          </FlexRow>
          <span className='font-sans font-size-xs'>{content.description || ''}</span>
        </FlexColumn>
      </FlexRow>
    </LinkCard>
  )
}

SkillCard.propTypes = {
  skill: PropTypes.shape({
    skillId: PropTypes.string.isRequired,
    version: PropTypes.number.isRequired,
    skillName: PropTypes.string.isRequired,
    skillContent: PropTypes.shape({
      enabled: PropTypes.bool,
      focuses: PropTypes.arrayOf(PropTypes.string),
      description: PropTypes.string,
      defaultPrompt: PropTypes.string
    })
  }).isRequired
}

export default SkillCard
